export default __webpack_public_path__ + "static/media/detail_main_img_13.483fcf2d.png";